@if (error(); as message) {
    <div class="p-4 text-center">
        <p class="text-danger mb-2">{{ message }}</p>
        <button type="button" class="btn btn-sm btn-outline-primary" (click)="retry.emit()">Prøv igen</button>
    </div>
} @else if (loading()) {
    <div class="p-5 text-center text-secondary">
        <span class="spinner-border spinner-border-sm me-2" aria-hidden="true"></span>
        Henter kørsler …
    </div>
} @else if (rows().length === 0) {
    <p class="text-secondary text-center py-5 mb-0">
        @if (searchActive()) {
            Ingen kørsler matcher søgningen.
        } @else {
            Ingen kørsler at vise.
        }
    </p>
} @else {
    <cdk-virtual-scroll-viewport [itemSize]="rowHeight" class="list-scroll">
        <button type="button" class="list-group-item list-group-item-action request-item"
            *cdkVirtualFor="let row of rows(); trackBy: trackById"
            [attr.data-request-id]="row.item.id"
            [class.active-item]="row.item.id === selectedId()"
            (click)="select.emit(row.item.id)">

            <div class="d-flex align-items-start">
                <span class="status-dot" [attr.data-group]="row.item.statusGroup"
                    [ngbTooltip]="statusTooltip(row.item)"
                    placement="top" container="body"></span>

                <div class="flex-grow-1 min-w-0">

                    <!-- 1 — hvad kørslen gør: ikon, skabelon, køretid -->
                    <div class="row-line fw-semibold">
                        <span class="line-main">
                            <app-task-badge [action]="row.item.action" [task]="row.item.task" />
                            <span class="text-truncate" appTruncateTooltip
                                ngbTooltip triggers="manual" container="body" placement="top-start">
                                {{ row.item.templateName ?? '—' }}
                            </span>
                        </span>
                        <span class="line-aside tabular">{{ row.item.runtime | formatRuntime }}</span>
                    </div>

                    <!-- 2 — kørslens egen beskrivelse, hele bredden -->
                    <div class="small text-truncate" appTruncateTooltip
                        ngbTooltip triggers="manual" container="body" placement="top-start">
                        {{ row.item.description }}
                    </div>

                    <!-- 3 — hvem den kørte for, og hvornår -->
                    <div class="row-line small text-secondary">
                        <span class="text-truncate" appTruncateTooltip
                            ngbTooltip triggers="manual" container="body" placement="top-start">
                            {{ row.customerName }} [{{ row.item.customerId }}] · {{ row.companyName }}
                        </span>
                        <!-- With a 7-day window, runtime alone cannot tell two rows apart. -->
                        <span class="line-aside tabular">{{ row.item.lastActivity | date:'dd-MM HH:mm' }}</span>
                    </div>

                    <!-- 4 — hvilken synkronisering, og hvor langt den nåede -->
                    <div class="row-line small text-secondary">
                        <span class="text-truncate" appTruncateTooltip
                            ngbTooltip triggers="manual" container="body" placement="top-start">
                            {{ row.synchronizationName }}
                        </span>
                        <span class="line-aside tabular">
                            @if (row.progress.total > 0) {
                                {{ row.progress.done }}/{{ row.progress.total }}
                            }
                        </span>
                    </div>
                </div>
            </div>
        </button>
    </cdk-virtual-scroll-viewport>

    @if (loadingMore()) {
        <div class="py-2 text-center text-secondary small flex-shrink-0">
            <span class="spinner-border spinner-border-sm me-2" aria-hidden="true"></span>
            Henter flere …
        </div>
    }
}
